export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_CATEGORY',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_CATEGORY_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_CATEGORY_FAIL',
  
};
